import { PointerEvent } from 'react';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { GateActionEnum, SetGatePositionPrecise } from 'lavva.exalushome/build/js/Services/Devices/Tasks/Tasks';
import { useNative } from '../../../../../hooks/native/use-native';
import { GatePreciseControlHook } from '../types';

export const useGatePreciseControl = (channel?: IDeviceChannel): GatePreciseControlHook => {
  const { fireVibration } = useNative();

  const open = async () => {
    const task = new SetGatePositionPrecise();
    task.GateControlAction = GateActionEnum.Open;
    fireVibration();
    await channel?.ExecuteTaskAsync(task);
  };

  const close = async () => {
    const task = new SetGatePositionPrecise();
    task.GateControlAction = GateActionEnum.Close;
    fireVibration();
    await channel?.ExecuteTaskAsync(task);
  };

  const stop = async () => {
    const task = new SetGatePositionPrecise();
    task.GateControlAction = GateActionEnum.Stop;
    fireVibration();
    await channel?.ExecuteTaskAsync(task);
  };

  const handleAction = async (action: GateActionEnum, position?: number) => {
    const task = new SetGatePositionPrecise();
    task.GateControlAction = action;
    if (typeof position === 'number' && position >= 0) {
      task.Position = position;
    }
    await channel?.ExecuteTaskAsync(task);
  };

  const handleSliderEvent = (event: PointerEvent<HTMLInputElement>) => {
    fireVibration();
    handleAction(GateActionEnum.Percentage, Number((event.target as HTMLInputElement).value));
  };

  return {
    open,
    close,
    stop,
    handleAction,
    handleSliderEvent,
  };
};
